module.exports = __webpack_public_path__ + "img/mono_35.16f342ec.png";